module.exports = __webpack_public_path__ + "img/troxaia.aaa8627e.jpg";